export const unsubscribeSectionContent = {
    id: 'unsubscribed',
    lightBg: true,
    lightText: false,
    lightTextDesc: true,
    topLine: 'Success',
    headline: 'Unsubscribed',
    description: 'You have been successfully unsubscribed from receving any letters from us.',
    buttonLabel: 'Go Home',
    imgStart: false,
    img: 'full-inbox-pana.svg',
    imgSourceHref: 'https://storyset.com/internet',
    imgSourceTitle: 'Online illustrations by Storyset',
    imgSourceIntro: 'illustration by storyset',
    imgSourceColor: 'on-light',
    imgSourceLocation: 'relative',
    imgSourceAlignment: 'bottom-center',
    imgSourceVerticalOffset: 0,
    imgSourceShowIcon: false,
    alt: 'Unsibscribe',
    dark: true,
    primary: true,
    darkText: true,
    routeTo: '/'
  };

  export const unsubscribeFailSectionContent = {
    id: 'unsubscription-fail',
    lightBg: true,
    lightText: false,
    lightTextDesc: true,
    topLine: 'Oops',
    headline: 'Something went wrong',
    description: 'You have not been unsubscribed. Please try later.',
    buttonLabel: 'Go Home',
    imgStart: false,
    img: 'full-inbox-pana.svg',
    imgSourceHref: 'https://storyset.com/internet',
    imgSourceTitle: 'Online illustrations by Storyset',
    imgSourceIntro: 'illustration by storyset',
    imgSourceColor: 'on-light',
    imgSourceLocation: 'relative',
    imgSourceAlignment: 'bottom-center',
    imgSourceVerticalOffset: 0,
    imgSourceShowIcon: false,
    alt: 'Unsibscribe',
    dark: true,
    primary: true,
    darkText: true,
    routeTo: '/'
  };